import {
  BeneficiaryInsightDimension,
  BeneficiaryTimeSeriesDimension,
} from '@repo/shared/dtos/beneficiary'
import { useEffect } from 'react'

import { FormType } from '../types'
import RangeDateBuckets from './date/RangeDateBuckets'
import SimpleDateBuckets from './date/SimpleDateBuckets'
import TimeSeriesDateBuckets from './date/TimeSeriesDateBuckets'

export default function DateBuckets({
  form,
  dimension,
  dimensionIndex,
  onChange,
}: {
  form: FormType
  dimension: BeneficiaryInsightDimension
  dimensionIndex: number
  onChange: (dimension: BeneficiaryInsightDimension) => void
}) {
  const mode = form.watch('dimensionModes')[dimensionIndex]!.date ?? 'simple'

  const updateDimension = (dimension: BeneficiaryInsightDimension) => {
    onChange(dimension)
  }

  useEffect(() => {
    if (mode === 'timeseries') {
      onChange({ ...dimension, timeSeries: { groupBy: 'day', range: { unit: 'day', value: 2 } } })
    }
  }, [mode])

  return (
    <div className="rounded-lg border border-primary-200 p-4 bg-gray-50 space-y-4">
      {mode === 'range' && <RangeDateBuckets dimension={dimension} onChange={updateDimension} />}
      {mode === 'simple' && <SimpleDateBuckets dimension={dimension} onChange={updateDimension} />}
      {mode === 'timeseries' && (
        <TimeSeriesDateBuckets
          dimension={dimension as BeneficiaryTimeSeriesDimension}
          onChange={updateDimension}
        />
      )}
    </div>
  )
}
